var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.062 10.2572C12.738 10.4312 12.3705 10.5234 12 10.5234C11.6295 10.5234 11.262 10.4312 10.9373 10.2572L0.018 4.41016C0.01425 4.44091 0 4.46866 0 4.50016V17.2502C0 17.6649 0.336 18.0002 0.75 18.0002H23.25C23.664 18.0002 24 17.6649 24 17.2502V4.50016C24 4.46866 23.9858 4.44166 23.982 4.41091L13.062 10.2572Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 0H0.75C0.336 0 0 0.33525 0 0.75V2.25C0 2.52675 0.15225 2.781 0.396 2.9115L11.646 8.93475C11.7563 8.994 11.8785 9.02325 12 9.02325C12.1215 9.02325 12.2437 8.994 12.354 8.93475L23.604 2.9115C23.8477 2.781 24 2.52675 24 2.25V0.75C24 0.33525 23.664 0 23.25 0Z",
    fill: "#444444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c78c3441c06bb9f69965ae95ead488df.svg";
export { ForwardRef as ReactComponent };